
import { useEffect } from 'react';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import FeaturedGuides from './components/FeaturedGuides';
import TopReviews from './components/TopReviews';
import ComparisonTable from './components/ComparisonTable';
import BlogSection from './components/BlogSection';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import TrustBar from './components/TrustBar';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      url: SITE_URL,
      name: 'Best Christmas Gift Reviews',
      description: 'Expert gift reviews and curated holiday gift guides to help you find the perfect Christmas presents.',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${SITE_URL}/reviews?q={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      '@id': `${SITE_URL}/#organization`,
      name: 'Best Christmas Gift Reviews',
      url: SITE_URL,
      logo: {
        '@type': 'ImageObject',
        url: 'https://public.readdy.ai/ai/img_res/d60c6eac-2a5e-4b32-8553-ec512239e7e6.png',
      },
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'hello@bestchristmasgiftreviews.com',
        contactType: 'customer support',
      },
    },
    {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/#webpage`,
      url: SITE_URL,
      name: 'Best Christmas Gift Reviews – Expert Holiday Gift Guides 2025',
      description: 'Discover the best Christmas gifts with expert reviews, curated holiday gift guides, and honest recommendations.',
      isPartOf: { '@id': `${SITE_URL}/#website` },
      publisher: { '@id': `${SITE_URL}/#organization` },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
        ],
      },
    },
  ],
};

export default function HomePage() {
  useEffect(() => {
    window.scrollTo(0, 0);

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'jsonld-home';
    script.textContent = JSON.stringify(homeJsonLd);
    document.head.appendChild(script);

    document.title = 'Best Christmas Gift Reviews – Expert Holiday Gift Guides 2025';

    return () => {
      const el = document.getElementById('jsonld-home');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#FFF9F5]">
      <Navbar />
      <Hero />
      <TrustBar />
      <CategoryGrid />
      <FeaturedGuides />
      <TopReviews />
      <ComparisonTable />
      <BlogSection />
      <Newsletter />
      <Footer />
    </div>
  );
}
